import { render, staticRenderFns } from "./BlockAssistant.vue?vue&type=template&id=009f0b44&scoped=true&"
import script from "./BlockAssistant.vue?vue&type=script&lang=js&"
export * from "./BlockAssistant.vue?vue&type=script&lang=js&"
import style0 from "./BlockAssistant.vue?vue&type=style&index=0&id=009f0b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f0b44",
  null
  
)

export default component.exports